import { capitalizeFirstLetter } from '@crazyegginc/hatch';

import { VisitorSection } from './components/sections/Visitors';
import { GoalsSection } from './components/sections/Goals';
import { ABTestingSection } from './components/sections/ABTesting';
import { SurveysSection } from './components/sections/Surveys';
import { CTAsSection } from './components/sections/CTAs';
import { RecordingsSection } from './components/sections/Recordings';
import { SnapshotsSection } from './components/sections/Snapshots';
import { WhatsNewSection } from './components/sections/WhatsNew';
//import { SuggestionsSection } from './components/sections/Suggestions';
import { ErrorsTrackingSection } from './components/sections/ErrorsTracking';
import { LiveSection } from './components/sections/Live';
import { SPECIAL_DATE_RANGES, FEATURES } from '../_global/constants';

export const DATE_RANGE_OPTIONS = [
  { value: 0, label: capitalizeFirstLetter(SPECIAL_DATE_RANGES.TODAY) },
  { value: 7, label: capitalizeFirstLetter(SPECIAL_DATE_RANGES.LAST_7_DAYS) },
  { value: 30, label: capitalizeFirstLetter(SPECIAL_DATE_RANGES.LAST_30_DAYS) },
];

export const SECTIONS = [
  { name: "What's new", Component: WhatsNewSection, feature: FEATURES.WHATS_NEW },
  //{ name: 'Suggestions', Component: SuggestionsSection },
  { name: 'Visitors', Component: VisitorSection, feature: FEATURES.WEB_ANALYTICS },
  { name: 'Goals', Component: GoalsSection, feature: FEATURES.GOALS },
  { name: 'Recordings', Component: RecordingsSection, feature: FEATURES.RECORDINGS },
  { name: 'Heatmaps', Component: SnapshotsSection, feature: FEATURES.SNAPSHOTS },
  { name: 'A/B Testing', Component: ABTestingSection, feature: FEATURES.AB_TESTING },
  { name: 'Surveys', Component: SurveysSection, feature: FEATURES.SURVEYS },
  { name: 'CTAs', Component: CTAsSection, feature: FEATURES.CTAS },
  { name: 'Errors Tracking', Component: ErrorsTrackingSection, feature: FEATURES.ERRORS_TRACKING },
  { name: 'Live Activity', Component: LiveSection, feature: FEATURES.LIVE_ACTIVITY },
];
